import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ProductContext } from "../../Contexts/ProductContext";
import { MdOutlineDiscount } from "react-icons/md";
import { CiDiscount1 } from "react-icons/ci";
import { AiOutlineClose } from "react-icons/ai";
import "./CartPriceStyle.css";
import { getAddressUtils, isEmpty, printDebugLog } from "../../Utils/utils";
import { buildOrderDetails, handleAddressChange, updateTotalBasedOnCoupon } from "../../Utils/cartUtils";
import { AuthContext } from "../../Contexts/AuthContext";
import { AddressForm } from "../AddressForm/AddressForm";
import { showActionToast } from "../global/ActionToast";
import { OfferType } from "../../Utils/constant";

const CartPrice = ({ setCouponModel }) => {
  const { productState,
    isLoading,
    orderState, orderDispatch, createOrder } =
    useContext(ProductContext);

  const { authState, setLoader } = useContext(AuthContext);
  const [isAddressForm, setIsAddressForm] = useState(false);

  const navigate = useNavigate();


  useEffect(() => {
    printDebugLog("isLoading", isLoading);
    if (isLoading) {
      setLoader(true);
    } else {
      setLoader(false);
    }
  }, [setLoader, isLoading]);

  const { subTotal, totalOfferApplied, cgstAmt, sgstAmt, totalQuantity, total, deliveryCharge
  } = orderState;
  const initialAddressForm = {
    id: "",
    name: authState?.user || "",
    mobileNum: authState?.mobile || "",
    addressType: "",
    landMark: "",
    address: "",
    city: "",
    state: "",
    country: "",
    zipCode: "",
  };
  const [selectedAddressId, setSelectedAddressId] = useState("");
  const [addressForm, setAddressForm] = useState(initialAddressForm);
  const selectedAddress = orderState?.destinationAddress || "";
  const selectedAddressDetails = (authState?.address || [])
    .find((address) => address.id === selectedAddressId);

  useEffect(() => {
    const listAddress = authState?.address || [];
    if (listAddress.length === 0) {
      setSelectedAddressId("");
      orderDispatch({ type: "setDesAddress", payload: "" });
      return;
    }

    const selected = listAddress.find((address) => address.id === selectedAddressId) || listAddress[0];
    setSelectedAddressId(selected.id);
    orderDispatch({ type: "setDesAddress", payload: getAddressUtils(selected) });
  }, [authState?.address, selectedAddressId, orderDispatch])

  const selectDeliveryAddress = (event) => {
    setSelectedAddressId(event.target.value);
    handleAddressChange(event, orderDispatch, authState?.address || []);
  };

  const getAddressOptionText = (address) => {
    const addressType = address.addressType ? ` (${address.addressType})` : "";
    if (!isEmpty(address.name)) {
      return `${address.name}${addressType}`;
    }

    const fullAddress = [
      address.landMark,
      address.address,
      address.city,
      address.state,
      address.country,
      address.zipCode,
    ].filter(Boolean).join(", ");
    return `${fullAddress || address.mobileNum || "Saved address"}${addressType}`;
  };

  const taxAmt = cgstAmt + sgstAmt;


  const checkoutHandler = async () => {
    if (!isEmpty(selectedAddress) && (productState?.cart?.length ?? 0) > 0) {
      await createOrder(buildOrderDetails(orderState, productState, authState?.mobile), selectedAddress)
    } else {
      if (isEmpty(selectedAddress)) {
        showActionToast({
          msg: "Please enter Delivery address",
          positiveBtnText: "Add",
          onSubmit: () => setIsAddressForm(!isAddressForm),
          negativeBtnText: "Cancel",
          onCancel: () => printDebugLog("user payment failed")
        });
      } else {
        showActionToast({
          msg: "Please add items to initiate payment",
          positiveBtnText: "Add",
          onSubmit: () => navigate("/products"),
          negativeBtnText: ""
        });
      }
    }

  };

  const getCouponApplied = () => {
    let couponAppliedAmt = 0.0;
    switch (parseInt(orderState.offerType)) {
      case OfferType.Flat:
        couponAppliedAmt = orderState.offerAmt;
        break;
      case OfferType.Percentage:
        couponAppliedAmt = (orderState.totalBeforeOffer * orderState.offerAmt) / 100;
        break;
      default:
        break;
    }
    return couponAppliedAmt.toFixed(2);
  }

  return (
    <div className="cart-price-card">
      <div>
        <div className="cart-price-coupen-apply">
          <p className="pc-center">
            <MdOutlineDiscount /> <span>Have a Coupon ?</span>
          </p>
          <button onClick={() => setCouponModel(true)}>Apply</button>
        </div>

        <hr />
        <h1 className="cart-price-heading">Price Details</h1>
        <hr />
      </div>
      <div className="cart-price-row">
        <p>Price Inc. tax({totalQuantity})</p>
        <p>₹ {subTotal.toFixed(2)}</p>
      </div>
      {
        (Number(deliveryCharge) || 0) > 0 &&
        <div className="cart-price-row">
          <p>Delivery Charges</p>
          <p>{deliveryCharge}</p>
        </div>
      }

      {
        !isEmpty(orderState.coupon) && <div className="cart-price-row">
          <p>Coupon Discount</p>
          <p>
            - ₹ {getCouponApplied()}
          </p>
        </div>
      }
      <div className="cart-discount-row">
        <p>Total Discount</p>
        <p>₹ {totalOfferApplied.toFixed(2)}</p>
      </div>


      {!isEmpty(orderState.coupon) && (
        <div className="cart-price-row cart-price-card-coupon">
          <p className="pc-center">
            <CiDiscount1 className="cart-coupon-icon" />
            {orderState.coupon}
          </p>
          <button
            onClick={() => {
              updateTotalBasedOnCoupon(orderState, "", OfferType.No_Offer, 0.0, orderDispatch);
            }}
          >
            <AiOutlineClose />
          </button>
        </div>
      )}

      <hr />
      <div className="cart-price-net">
        <p>Total Amount</p>
        <p>₹ {total.toFixed(2)}</p>
      </div>
      <div className="cart-tax-row">
        <p>Tax Breakup(CGST + SGST)</p>
        <p>₹ {taxAmt.toFixed(2)}</p>
      </div>
      <hr />
      <p className="discount-msg">
        You will save <span>₹ {totalOfferApplied.toFixed(2)}</span> on this order
      </p>

      {/* -------- Delivery Address Section (ABOVE Checkout) -------- */}
      <div className="delivery-section">
        <div className="delivery-row">
          <label htmlFor="deliveryAddress" className="delivery-label">
            Deliver to
          </label>

          <select
            id="deliveryAddress"
            className="delivery-select"
            value={selectedAddressId}
            onChange={selectDeliveryAddress}
          >
            {authState?.address.length === 0 ? (
              <option value="">No saved addresses</option>
            ) : (
              authState?.address.map((addr) => (
                <option key={addr.id} value={addr.id}>
                  {getAddressOptionText(addr)}
                </option>
              ))
            )}
          </select>
        </div>

        {/* Optional: quick preview of selected address */}
        {selectedAddress && (
          <div className="delivery-preview">
            {selectedAddressDetails?.addressType && (
              <strong className="delivery-preview-type">
                ({selectedAddressDetails.addressType})
              </strong>
            )}
            <div>{selectedAddress}</div>
          </div>
        )}

        <button
          type="button"
          className="delivery-add-btn"
          onClick={() => setIsAddressForm(!isAddressForm)}
        >
          + Add another delivery address
        </button>
        {isAddressForm && (
          <AddressForm
            setIsAddressForm={setIsAddressForm}
            addressForm={addressForm}
            setAddressForm={setAddressForm}
            initialAddressForm={initialAddressForm}
          />
        )}
      </div>
      {/* ----------------------------------------------------------- */}

      <button className="cart-price-checkout-btn" onPointerDown={() => checkoutHandler()}>
        Checkout
      </button>
    </div>
  );
};
export { CartPrice };
